import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import ArtworkDetail from "./pages/ArtworkDetail";
import Artists from "./pages/Artists";
import ArtistProfile from "./pages/ArtistProfile";
import Upload from "./pages/Upload";
import UploadSuccess from "./pages/UploadSuccess";
import Cart from "./pages/Cart";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Membership from "./pages/Membership";
import MembershipSuccess from "./pages/MembershipSuccess";
import MyPurchases from "./pages/MyPurchases";
import Dashboard from "./pages/Dashboard";
import MyWorks from "./pages/MyWorks";
import Favorites from "./pages/Favorites";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#121212',
                color: '#F5F5F0',
                border: '1px solid rgba(255,255,255,0.1)',
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="gallery/:category" element={<Gallery />} />
              <Route path="artwork/:id" element={<ArtworkDetail />} />
              <Route path="artists" element={<Artists />} />
              <Route path="artist/:id" element={<ArtistProfile />} />
              <Route path="upload" element={<Upload />} />
              <Route path="upload/success" element={<UploadSuccess />} />
              <Route path="cart" element={<Cart />} />
              <Route path="checkout/success" element={<CheckoutSuccess />} />
              <Route path="membership" element={<Membership />} />
              <Route path="membership/success" element={<MembershipSuccess />} />
              <Route path="purchases" element={<MyPurchases />} />
              <Route path="my-works" element={<MyWorks />} />
              <Route path="favorites" element={<Favorites />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
